/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestionsSkeleton.defs'
export { main as default } from './getSuggestionsSkeleton.defs'
